import React from 'react';

const Module = ({ block, style }) => {
  const className = `module module-${block?.textClassName}`;
  return (
    <div className={className} style={style}>
      {block?.text?.split('-').join(' ')}
    </div>
  );
};

export default Module;
